import React, {Component} from 'react';
import {PropTypes} from 'prop-types';

class ClickableDiv extends Component {

  handleKeyPress = (e) => {
    let code = e.keyCode || e.which;
    if(code === 13) { //13 is the enter keycode
      this.props.onClick();
    }
  };

  render() {
    return (
        <div className={this.props.className} tabIndex="0" onClick={this.props.onClick} onBlur={this.props.onBlur} onKeyPress={this.handleKeyPress}>
          {this.props.children}
        </div>
    );
  }
}

ClickableDiv.propTypes = {
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.string
};

export default ClickableDiv;